/* eslint-disable no-loop-func */
/* eslint-disable no-plusplus */

import { useAtom } from 'jotai';
import { userRecordAtom } from '../../shared/state/atoms';
import { useToast } from '../../shared/hooks';
import { useSupportTicketService } from '../../shared/services';

export default function useCreateSupportTicketModal() {
  const [user] = useAtom(userRecordAtom);
  const { showSuccess, showError } = useToast();
  const { createSupportTicket } = useSupportTicketService();

  const handleCreateSupportTicket = async (formData) => {
    const data = {
      source: 'School Portal',
      message: formData.message,
      isResolved: false,
      contact: {
        emailAddress: user.contact.emailAddress,
      },
      details: {
        name: user.details.name,
        schoolName: user?.school.name,
        className: 'N/A',
      },
    };

    createSupportTicket(data)
      .then(() => showSuccess('Support ticket created successfully!'))
      .catch((error) => showError(error.message));
  };

  return {
    handleCreateSupportTicket,
  };
}
